export const model = {
  id: null,
  name: '',
  permissions:[],
  model_permissions:[],      
  created_at: '',
  updated_at: '',
};
